import React from "react";
import { connect } from 'react-redux';
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from 'react-router-dom';
import { postCDocAttachment, postCDocFile } from "../Actions/ControlledDocAPI";
import { deleteAttachmentInBucket } from "../Actions/CommonAPI";
import $ from "jquery";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
var fileDatas = [];
class ControlledDocFileAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fileinfo: {
                fileName: "",
                fileGuid: "",
                createdBy: currentuser.name,
            },
            file: '',
            fileName: ''
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }


    componentDidMount(){
        const{dispatch}=this.props;
        dispatch({ type: 'SubBannerTitle', data: "Controlled Documents" });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { CDocAttachment, dispatch } = nextProps;
        if (CDocAttachment) {
            prevState.fileinfo.fileName = CDocAttachment.FileName;
            prevState.fileinfo.fileGuid = CDocAttachment.Guid;
        }
        if (prevState.file !== "") {
            dispatch(postCDocAttachment(prevState.file));
            prevState.file = ""
        }
    }

    AddFiles() {
        const { dispatch, match, history, t } = this.props;
        let id = match.params.id;
        if(this.state.fileName?.trim() !== ""){
            dispatch(postCDocFile(id, this.state.fileinfo, history,t));        
            if (fileDatas.length > 0) {
              this.props.dispatch(deleteAttachmentInBucket(fileDatas));
              fileDatas = [];
            } 
        } else {
            $("#FileErrorMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
        }
   
    }

    handleInputChange(e) {
        this.setState({ file: e.target.files[0], fileName: e.target.files[0].name });
    }

    clearInput() {               
       // this.props.dispatch(deleteAttachmentInBucket(this.state.fileinfo.fileGuid,this.state.fileinfo.fileName));
       let obj1 = {
        filename : this.state.fileinfo.fileName,
        guid : this.state.fileinfo.fileGuid,
      }
      fileDatas.push(obj1); 
       this.setState({ file: "", fileName: "" });
        let obj = {
            FileName : "",
            Guid : ""
           };
           this.setState({ file: "", fileName: "" });
           this.props.dispatch({
            type: "postCDocAttachmentUploadSuccess",
            data: obj,
          });  
    }

    render() {
        const { CDocAttachment,t } = this.props;
        console.log("Attachment details", CDocAttachment, this.state.fileinfo)
        return (
            <div className="pb-3">

                <div className="full-height">
                    <div className="resource-list-auth-date row pt-3 ">
                        <div className='col-lg-12'>
                            <div className="panel-box">
                                <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                    <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>{t("ControlledDocumentsScreenContent.AddFiles")}</h5>
                                    </div>
                                </div>
                                <div className="row search-filter-box">
                                    <div className="col-lg-6">
                                        <label className="form-label">{t("FlagScreen.Attachment")}</label><br></br>
                                        <div class="input-group ">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                {t("CommonText.BrowseFile")}
                                                    <input type="file" 
                                                    id="files" 
                                                    style={{marginRight: 40}}
                                                    name="fileName" 
                                                    onChange={e => this.handleInputChange(e)}
                                                        onClick={(event) => { event.currentTarget.value = null }}
                                                    />
                                                </span>
                                            </div>
                                            <input type="text" class="form-control" placeholder={t("CommonText.Nofilechoosen")} value={this.state.fileName} />
                                            
                                            {this.state.fileName ?
                                                <div class="input-group-append" style={{ cursor : "pointer" }}>
                                                    <i class="fa fa-times input-group-text padding-top-10px" aria-hidden="true" onClick={() => this.clearInput()}></i>
                                                </div> : ''
                                            }
                                        </div>
                                        <span id="FileErrorMsg" className="spanErrMsg"></span>
                                    </div>
                                    <div className="col-lg-12 search-filter-box">
                                        <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.AddFiles()}> {t("ComplianceandBudgetScreen.Submit")} </button>

                                            <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> {t("ComplianceandBudgetScreen.Cancel")} </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
    hideSidePanel() {
        const { dispatch, history } = this.props;;
        dispatch({ type: "ShowSidePan", data: false });
        history.goBack();
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        CDocAttachment: state.ControlledDocReducer.CDocAttachment,
    }
}
export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(ControlledDocFileAdd)));